<template>
<div class="contract-view">
    <div class="popup" :class="{ 'is-active': isFinalCompleteUpdateLandContract }">
      <div class="overlay"></div>
      <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
        <div class="card">
          <div class="card-body text-center">
            <div class="text-center p-2">
              <h3 class="font-weight-normal mb-2">ทำการแก้ไขรายการบ้านเรียบร้อยแล้ว</h3>
              <p class="pr-4 pl-4">โปรดดูได้ที่รายละเอียดสัญญา</p>
            </div>
            <a class="btn btn-primary btn-lg btn-block mt-5 mb-4" :href="$util.url('member/transaction-contract#/view/' + this.newChildContractId)">ไปที่สัญญาใหม่</a>
          </div>
        </div>
      </div>
    </div>


    <div class="bg-white pr-2 pl-2 pt-4 pb-4 text-center shadow-lg">
      <h5 class="font-weight-normal mb-1 text-danger">แก้ไขรายการบ้าน/ที่ดินตามแผนผังแนบท้ายสัญญา</h5>
      <p class="font-weight-normal m-0">#{{ contract_no }}</p>
    </div>
    <div class="container">

      <div class="row mt-4 mb-4">
        <div class="col">
            <h6 class="font-weight-normal text-secondary">แปลง</h6>
            <input class="form-control" name="land_plot" type="text" v-model="land_plot" />
        </div>
        <div class="col">
            <h6 class="font-weight-normal text-secondary">โฉนด</h6>
            <input class="form-control" name="land_deed" type="text" v-model="land_deed" />
        </div>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col">
            <h6 class="font-weight-normal text-secondary">เลขที่</h6>
            <input class="form-control" name="land_no" type="text" v-model="land_no" />
        </div>
        <div class="col">
            <h6 class="font-weight-normal text-secondary">ระวาง</h6>
            <input class="form-control" name="land_section" type="text" v-model="land_section" />
        </div>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col">
            <h6 class="font-weight-normal text-secondary">อำเภอ</h6>
            <input class="form-control" name="land_district" type="text" v-model="land_district" />
        </div>
        <div class="col">
            <h6 class="font-weight-normal text-secondary">ตำบล</h6>
            <input class="form-control" name="land_amphur" type="text" v-model="land_amphur" />
        </div>
      </div>


      <div class="row mt-4 mb-4">
        <div class="col">
            <h6 class="font-weight-normal text-secondary">จังหวัด</h6>
            <input class="form-control" name="land_province" type="text" v-model="land_province" />
        </div>
        <div class="col">
            <h6 class="font-weight-normal text-secondary">เป็นจำนวนเนื้อที่ประมาณ</h6>
            <input class="form-control" name="land_area" type="text" v-model="land_area" />
        </div>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col">
            <h6 class="font-weight-normal text-secondary">กว้างประมาณ</h6>
            <input class="form-control" name="land_width" type="text" v-model="land_width" />
        </div>
        <div class="col">
            <h6 class="font-weight-normal text-secondary">ยาวประมาณ</h6>
            <input class="form-control" name="land_height" type="text" v-model="land_height" />
        </div>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col">
            <h6 class="font-weight-normal text-secondary">และอาคารบ้านเลขที่</h6>
            <input class="form-control" name="land_and_house_no" type="text" v-model="land_and_house_no" />
        </div>
        <div class="col">
        </div>
      </div>

      <div class="row pt-4 pb-2">
          <button class="btn btn-primary btn-lg btn-block" style="margin-top:6px;margin-bottom:6px;" @click="submitPatch()">บันทึก</button>
          <button class="btn btn-light btn-lg btn-block" style="margin-top:6px;margin-bottom:6px;" @click="goBack">ย้อนกลับ</button>
      </div>
    </div>

    
</div>
</template>

<script>
export default {
  data: () => ({
    isFinalCompleteUpdateLandContract: false,
    newChildContractId: 0,

    land_plot: null,
    land_deed: null,

    land_no: null,
    land_section: null,
    land_district: null,
    land_amphur: null,

    land_province: null,
    land_area: null,
    
    land_width: null,
    land_height: null,
    land_and_house_no: null,

    contract_no: "",
  }),
  async created () {
    const result = await this.$api.contract.listLand(this.$route.params.id);

    this.contract_no = result.data.contract.contract_no;

    this.land_plot = result.data.land_plot;
    this.land_deed = result.data.land_deed;

    this.land_no = result.data.land_no;
    this.land_section = result.data.land_section;
    this.land_district = result.data.land_district;
    this.land_amphur = result.data.land_amphur;

    this.land_province = result.data.land_province;
    this.land_area = result.data.land_area;
    
    this.land_width = result.data.land_width;
    this.land_height = result.data.land_height;
    this.land_and_house_no = result.data.land_and_house_no;

  },
  mounted () {

  },
  beforeDestroy () {

  },
  watch: {
  },
  methods: { 


    isCalculating () {
      if (this.calculateQueue.length > 0) return true
      return false
    },
    async submitPatch() {

      let patch = {
        'land_plot': this.land_plot,
        'land_deed': this.land_deed,

        'land_no': this.land_no,
        'land_section': this.land_section,
        'land_district': this.land_district,
        'land_amphur': this.land_amphur,

        'land_province': this.land_province,
        'land_area': this.land_area,
        
        'land_width': this.land_width,
        'land_height': this.land_height,
        'land_and_house_no': this.land_and_house_no
      };

      const result = await this.$api.contract.updateLand(this.$route.params.id, patch);

      alert("ทำรายปรับปรุงข้อมูลเรียบร้อยแล้ว");
    },
    goBack () {
      this.$router.push({ name: 'transaction-contract-view', params: { id: this.$route.params.id } });
    },
  },
  components: {
  },
  props: [] // isShowCredit passed by routes, isDisputing passed by routes
}
</script>

<style lang="scss">
.contract-view {
  .active-user-indicator {
      display: none;
    }
  .is-active-user {
    .active-user-indicator {
      display: inline-block;
    }
  }
  .disputing-old-value {
    margin-top: 6px;
    font-size: 14px;
    opacity: 0.5;
    &::before {
      content: '(ค่าเดิม: '
    }
    &::after {
      content: ')'
    }
  }
  .disputing-old-value-2 {
    margin-top: 6px;
    font-size: 14px;
    opacity: 0.5;
  }
}
</style>
